export enum NotifierEvents {
  MARK_READ = 'notifier:mark-read',
  DISMISS = 'notifier:dismiss',
  REVOKE_DISMISSION = 'notifier:revoke-dismission',
}
